<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_3"></a><a id="ch02">JULY 2006</a></h2><a id="ch02">
<p class="noindent1">Five minutes that matter.</p>
<p class="noindent">Across the desk. The spot beside her, empty.</p>
<p class="indent">“I don’t know anymore,” she says. “I just don’t know.” Presses her palms into her temples, hoping her head doesn’t explode.</p>
<p class="indent">“Whatever you decide,” the woman says.</p>
<p class="indent">It is their secret.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?10029736